export const removeLeadingSlash = (path: string) => {
    return path.slice(1);
};
